import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { INCLocationOnDepartmentHttpPostPutModel } from '../../models/location-on-department/nc-location-on-department.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class LocationOnDepartmentApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/LocationOnDepartments`;
  }

  constructor(private http: HttpClient) {}

  loadLocationOnDepartment(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IdName[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IdName[]>>(this.url, { params });
  }

  loadAllLocationOnDepartment(): Observable<IdName[]> {
    const url = `${this.url}/All?departmentId=${getDepartmentId()}`;
    return this.http.get<IdName[]>(url);
  }

  loadLocationOnDepartmentById(id: string): Observable<IdName> {
    const url = `${this.url}/${id}`;
    return this.http.get<IdName>(url);
  }

  createLocationOnDepartment(
    locationOnDepartment: INCLocationOnDepartmentHttpPostPutModel
  ): Observable<INCLocationOnDepartmentHttpPostPutModel> {
    return this.http.post<INCLocationOnDepartmentHttpPostPutModel>(this.url, locationOnDepartment, {
      headers,
    });
  }

  updateLocationOnDepartment(
    locationOnDepartment: INCLocationOnDepartmentHttpPostPutModel
  ): Observable<INCLocationOnDepartmentHttpPostPutModel> {
    const url = `${this.url}/${locationOnDepartment.id}`;
    return this.http.put<INCLocationOnDepartmentHttpPostPutModel>(url, locationOnDepartment, {
      headers,
    });
  }

  deleteLocationOnDepartment(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
